import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import {
  IConfig,
  NgxMaskDirective,
  NgxMaskPipe,
  provideNgxMask,
} from 'ngx-mask';
import { AppMaterialModule } from '@app/app-material.module';
import { AnimationsModule } from '@shared/animations/animations.module';
import { MinhaContaComponent } from '@modules/configuracoes/pages/minha-conta/minha-conta.component';
import { MinhaContaController } from '@modules/configuracoes/controllers';
import { ComponentsModule } from "@app/shared/components/components.module";

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [MinhaContaComponent],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    AppMaterialModule,
    NgxMaskDirective,
    NgxMaskPipe,
    AnimationsModule,
    ComponentsModule
],
  providers: [provideNgxMask(maskConfig), MinhaContaController],
})
export class ConfiguracoesModule {}
